export default {
      id: "as-hearing-assistant-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-hearing-assistant",
      toString: function () {
        return this.url;
      }
    }